import deviceTacitcs from "../DeviceTactics"
/**
 *数据路由
 */
const device = [
    {
        name: '设备告警策略',
        path: '/device/deviceTacitcs',
        component: deviceTacitcs
    },
];
export default device
